module.exports = __webpack_public_path__ + "static/images/be051f49bd87cedd732df3a7262f6ff3.webp";